import apiClient from "QueryClient/axiosClient";

export const getSlotsByDate = ({ start, end }) => {
  return apiClient.get(`/oneGradSlot/getSlotsByDate?start=${start}&end=${end}`);
};
